module.exports = __webpack_public_path__ + "img/from_comfort_to_community.3e84d2ce.png";